import { cloneElement, ReactElement, ReactNode } from 'react';
import FormInputGroup, { FormInputGroupProps } from 'components/forms/FormInputGroup';
import { EvidenceSection } from 'components/forms/evidence-field/use-evidence-sections';

export interface PositionedEvidenceField {
  evidenceFieldId?: number;
  sectionId: number;
  order: number;
}

/** Orders layout metadata without changing caller-owned definition arrays or values. */
export default function EvidenceSections<T extends PositionedEvidenceField>({
  module,
  sections,
  fields,
  builtinGroups,
  renderFields,
}: {
  module: 'devices' | 'people';
  sections: EvidenceSection[];
  fields: T[];
  builtinGroups: Record<string, ReactElement<FormInputGroupProps> | false>;
  renderFields: (fields: T[]) => ReactNode;
}) {
  return (
    <>
      {sections
        .filter((section) => section.module === module)
        .slice()
        .sort((a, b) => b.order - a.order || a.sectionId - b.sectionId)
        .map((section) => {
          const sectionFields = fields
            .filter((field) => field.sectionId === section.sectionId)
            .sort((a, b) => b.order - a.order || (a.evidenceFieldId ?? 0) - (b.evidenceFieldId ?? 0));
          const builtin = section.builtinKey ? builtinGroups[section.builtinKey] : undefined;
          const inputs = sectionFields.length ? renderFields(sectionFields) : null;
          if (builtin) {
            return cloneElement(builtin, { key: section.sectionId }, builtin.props.children, inputs);
          }
          return inputs ? (
            <FormInputGroup key={section.sectionId} groupTitle={section.name}>
              {inputs}
            </FormInputGroup>
          ) : null;
        })}
    </>
  );
}
